/**
 * Перечень акций
 *
 * @param {Object} params
 * @param {String} params.urlApi - url обращения к api
 * @param {String} params.couponsList - список акций
 * @param {String} params.citySelect - селект города
 * @param {String} params.choiceTag - выбор тега
 * @param {String} params.tagId - Id тега
 * @param {String} params.choiceClinic - выбор клиники
 */
$.fn.couponsList = function (params) {

    const $self = $(this);
    const $couponsList = $self.find(params.couponsList);
    const $choiceTag = $self.find(params.choiceTag);
    const urlApi = params.urlApi;
    const citySelect = params.citySelect;
    const choiceClinic = params.choiceClinic;

    let tagsIds = [];
    let activeClinic = 0;

    /**
     * Выбор тега
     */
    $choiceTag.click(function () {

        let selectedTagId = +$(this).data('coupons-tag-id');

        $choiceTag.filter(function () {
            let currentTagId = +$(this).data('coupons-tag-id');
            if (selectedTagId !== currentTagId) {
                $(this).prop('checked', false);
            } else {
                $(this).prop('checked', true);
            }
        });

        tagsIds = $choiceTag.filter(function () {
            return $(this).prop('checked');
        }).map(function () {
            return parseInt($(this).data('coupons-tag-id'), 10);
        }).get();

        update();
    });

    /**
     * Выбор клиники
     */
    $self.on('click', choiceClinic, function () {

        let clinic = +$(this).attr('data-value');

        if (clinic !== activeClinic) {
            activeClinic = clinic;
            update();
        }
    });

    /**
     * Рендер списка акций
     */
    const update = function () {

        let url = $couponsList.attr(urlApi);

        $.ajax({
            method: 'GET',
            url: url,
            data: {
                tags_ids: tagsIds.length ? tagsIds : [0],
                city_id: $self.find(citySelect).val(),
                clinic_id: activeClinic,
            }
        }).done(function (res) {
            $couponsList.html(res);
        }).fail(function (error) {
            console.log(error);
        });

    };

    return this;
};

// инициализация
const init = function () {

    $('#coupons-list-module').couponsList({
        urlApi: 'data-url-api',
        couponsList: $('#coupons-list'),
        citySelect: '.city-switcher-options .active:first',
        choiceTag: $('[data-coupons-choice-tag="true"]'),
        tagId: 'data-coupons-tag-id',
        choiceClinic: '[data-choice-clinic="true"] .c-select-option',
    });
};

if ($('#coupons-list-module').length > 0) {
    init();
}
